import { LinkDefinition } from "@hermes/utils-generic-services-head";

import { MediaPicture, MediaQueryOption } from "../../model/media.types";
import { toPosterUrlOptions } from "../../pipes/poster-url/poster-url.pipe";

export function mediaQueryOptionsToLinkDefinition(
    mediaQueryOption: MediaQueryOption,
    desktopImageUrl: string,
    mobileImageUrl?: string,
): LinkDefinition {
    return {
        rel: "preload",
        href: toPosterUrlOptions(desktopImageUrl, {
            mobileUrl: mobileImageUrl,
            size: mediaQueryOption.size,
            width: mediaQueryOption.width,
        }),
        as: "image",
        fetchpriority: "high",
        media: mediaQueryOption.mediaQuery,
    };
}

export function generateLinkDefinitions(
    preloadPoster: boolean,
    media?: MediaPicture,
    mediaOptions?: MediaQueryOption[],
): LinkDefinition[] {
    if (preloadPoster && media && media.desktopImage && mediaOptions) {
        const desktopImageUrl = media.desktopImage;
        const mobileImageUrl = media.mobileImage;
        const linkDefitions: LinkDefinition[] = mediaOptions.map((v) =>
            mediaQueryOptionsToLinkDefinition(
                v,
                desktopImageUrl,
                mobileImageUrl,
            ),
        );
        return linkDefitions;
    }
    return [];
}
